"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _excluded = ["classes", "title", "contentText", "label", "onConfirm", "commentVal"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    button: {
      margin: theme.spacing(1)
    },
    textField: {
      marginTop: '1rem',
      fontSize: 12
    },
    dialogPaper: {
      minWidth: '20rem',
      minHeight: '20rem'
    },
    dialogContentRoot: {
      display: 'flex',
      flexDirection: 'column'
    }
  };
};
var AddComment = /*#__PURE__*/function (_Component) {
  function AddComment(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, AddComment);
    _this = _callSuper(this, AddComment, [props]);
    _this.state = {
      value: props.commentVal
    };
    ['handleInputChange', 'handleConfirm', 'handleClose'].map(function (name) {
      return _this[name] = _this[name].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(AddComment, _Component);
  return (0, _createClass2["default"])(AddComment, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
      this.setState((0, _defineProperty2["default"])({}, name, value));
    }
  }, {
    key: "handleConfirm",
    value: function handleConfirm() {
      var value = this.state.value;
      this.props.onConfirm(value);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        title = _this$props.title,
        contentText = _this$props.contentText,
        label = _this$props.label,
        onConfirm = _this$props.onConfirm,
        commentVal = _this$props.commentVal,
        other = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);

      //var commentVal = '';

      //let row = rows.find(r => r.id === rowID);
      //if (row) {
      //  let service = row.services.find(d => d.serviceID == serviceID);
      //  commentVal = service.comment;
      //}

      return /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
        classes: {
          paper: classes.dialogPaper
        },
        onClose: this.handleClose,
        "aria-labelledby": "simple-dialog-title"
      }, other), /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, {
        id: "simple-dialog-title"
      }, title), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, {
        className: classes.dialogContentRoot
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          flexGrow: 1
        }
      }, contentText), /*#__PURE__*/_react["default"].createElement(_material.TextField, {
        inputProps: {
          maxLength: 100
        },
        className: classes.textField,
        fullWidth: true,
        name: "value",
        label: label,
        multiline: true,
        margin: "dense",
        defaultValue: commentVal,
        onChange: function onChange(event) {
          return _this2.handleInputChange(event);
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: this.handleClose
      }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: this.handleConfirm,
        disabled: commentVal === '' || commentVal === undefined ? !this.state.value : false
      }, "Confirm")));
    }
  }]);
}(_react.Component);
AddComment.propTypes = {
  title: _propTypes["default"].string,
  onClose: _propTypes["default"].func.isRequired,
  onConfirm: _propTypes["default"].func.isRequired,
  label: _propTypes["default"].string,
  contentText: _propTypes["default"].string
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(AddComment);